import * as React from 'react'
import { Input } from 'uxp/components'
import { IBaseProperty, IUIPropertyDefinition } from '../common'
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle } from './common'
import { hasProperty, hasValue } from '../../../util'
import ActionEditorLink, { extractAction, IAction, IActionEditorLinkSettings } from '../action-editor/ActionEditor'
import IconPickerField from '../icon-selector/IconPickerField'
import jp from 'jsonpath'
import { $L } from '../../../localize';

interface IconButtonPropertyProps extends IBaseProperty {
    icon: string
    iconSize?: string
    color?: string,
    backgroundColor?: string,
    onClick: IAction,
}

export function extractIconButtonProperties(props: IconButtonPropertyProps, defaultIcon?: string) {

    if (!props) return { icon: defaultIcon || '', onClick: extractAction(null) }

    let icon = hasValue(props.icon) ? props.icon : defaultIcon
    let onClick = extractAction(props.onClick)


    let buttonStyles: React.CSSProperties = {}
    if (hasValue(props.color)) buttonStyles.color = props.color
    if (hasValue(props.backgroundColor)) buttonStyles.backgroundColor = props.backgroundColor
    if (hasValue(props.iconSize)) buttonStyles.fontSize = props.iconSize

    return { icon, onClick, buttonStyles }
}

export function IconButtonProperty(title: string, props: IconButtonPropertyProps, actionEditorSettings?: IActionEditorLinkSettings): IUIPropertyDefinition<IconButtonPropertyProps> {

    return {
        defaults: props,
        render: (props, uxpContext, contextData, containerId, customProps) => {

            let _props = props?.uiProps || { icon: '', onClick: { type: 'open-url' } }

            return <PropertyContainer>
                <PropertyContainerTitle>{title || $L('widgetdesigner.props.icon-button', 'Icon Button')}</PropertyContainerTitle>

                <PropertyGroup>
                    <Property>
                        <PropertyTitle>{$L('widgetdesigner.props.icon', 'Icon')}</PropertyTitle>
                        <IconPickerField
                            value={_props.icon}
                            onChange={s => {
                                jp.apply(_props, '$.icon', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>

                    {hasProperty(_props, '$.iconSize') &&
                        <Property>
                            <PropertyTitle>{$L('widgetdesigner.props.size-px', 'Size (px)')} </PropertyTitle>
                            <Input
                                type='number'
                                value={escapeUnit(_props.iconSize || '', 'px')}
                                onChange={s => {
                                    let num = Number(s) || 0
                                    if (num < 8) s = '8'
                                    else if (num > 200) s = '200'

                                    jp.apply(_props, '$.iconSize', () => (s + 'px'))
                                    props.onChange(_props)
                                }}
                                className="widget-designer-input"
                                inputAttr={{
                                    max: '200',
                                    min: '8'
                                }}
                            />
                        </Property>
                    }

                    {hasProperty(_props, '$.color') &&
                        <Property>
                            <PropertyTitle>{$L('widgetdesigner.props.text-color', 'Text Color')}</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.color || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.color', () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                    }

                    {hasProperty(_props, '$.backgroundColor') &&
                        <Property>
                            <PropertyTitle>{$L('widgetdesigner.props.background-color', 'Background Color')}</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.backgroundColor || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.backgroundColor', () => (s))
                                    props.onChange(_props)
                                }}
                            />
                        </Property>
                    }


                    {hasProperty(_props, '$.onClick') &&
                        <Property>
                            <PropertyTitle>{$L('widgetdesigner.props.on-click', 'On click')}</PropertyTitle>
                            <ActionEditorLink
                                uiProps={props.parentUIProps}
                                designer={props.designer}
                                action={_props.onClick}
                                onChange={s => {
                                    jp.apply(_props, '$.onClick', () => (s))
                                    props.onChange(_props)
                                }}
                                uxpContext={uxpContext}
                                settings={actionEditorSettings}
                                contextData={contextData}
                            />
                        </Property>
                    }

                </PropertyGroup>
            </PropertyContainer>

        }
    }

}